import { createAction } from '@reduxjs/toolkit';

export const setAllExpanded = createAction('expandedMenu/ALL');

export const setExpanded = createAction('expandedMenu/Single', (id: string) => {
    return {
        payload: id,
    };
});
